import { render, staticRenderFns } from "./ForumChatMainEmpty.vue?vue&type=template&id=b7947e1c&scoped=true"
import script from "./ForumChatMainEmpty.vue?vue&type=script&lang=js"
export * from "./ForumChatMainEmpty.vue?vue&type=script&lang=js"
import style0 from "./ForumChatMainEmpty.vue?vue&type=style&index=0&id=b7947e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7947e1c",
  null
  
)

export default component.exports